// Static popular-cities list, ordered by population.
// US: ~200 cities. Canada: ~100. Free-text is allowed when nothing matches.
export const COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  // Rest of world alphabetical
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AT', name: 'Austria' },
  { code: 'AU', name: 'Australia' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BR', name: 'Brazil' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'CN', name: 'China' },
  { code: 'DE', name: 'Germany' },
  { code: 'DK', name: 'Denmark' },
  { code: 'ES', name: 'Spain' },
  { code: 'FR', name: 'France' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IN', name: 'India' },
  { code: 'IT', name: 'Italy' },
  { code: 'JP', name: 'Japan' },
  { code: 'MX', name: 'Mexico' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NO', name: 'Norway' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'PT', name: 'Portugal' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SE', name: 'Sweden' },
  { code: 'SG', name: 'Singapore' },
  { code: 'ZA', name: 'South Africa' },
];

// Cities are keyed by country code, values are arrays sorted by population.
// For brevity in this repo, we include a solid subset (top ~60 for US, ~30 for CA,
// plus a couple flagship cities for other countries). Free-text always works.
export const CITIES = {
  US: [
    'New York, NY','Los Angeles, CA','Chicago, IL','Houston, TX','Phoenix, AZ',
    'Philadelphia, PA','San Antonio, TX','San Diego, CA','Dallas, TX','San Jose, CA',
    'Austin, TX','Jacksonville, FL','Fort Worth, TX','Columbus, OH','Charlotte, NC',
    'Indianapolis, IN','San Francisco, CA','Seattle, WA','Denver, CO','Washington, DC',
    'Boston, MA','El Paso, TX','Nashville, TN','Detroit, MI','Oklahoma City, OK',
    'Portland, OR','Las Vegas, NV','Memphis, TN','Louisville, KY','Baltimore, MD',
    'Milwaukee, WI','Albuquerque, NM','Tucson, AZ','Fresno, CA','Mesa, AZ','Sacramento, CA',
    'Atlanta, GA','Kansas City, MO','Colorado Springs, CO','Miami, FL','Raleigh, NC',
    'Omaha, NE','Long Beach, CA','Virginia Beach, VA','Oakland, CA','Minneapolis, MN',
    'Tulsa, OK','Arlington, TX','Tampa, FL','New Orleans, LA','Wichita, KS',
    'Cleveland, OH','Bakersfield, CA','Aurora, CO','Anaheim, CA','Honolulu, HI',
    'Santa Ana, CA','Riverside, CA','Corpus Christi, TX','Lexington, KY','Stockton, CA',
    'Henderson, NV','Saint Paul, MN','St. Louis, MO','Cincinnati, OH','Pittsburgh, PA',
    'Greensboro, NC','Anchorage, AK','Plano, TX','Lincoln, NE','Orlando, FL',
    'Irvine, CA','Newark, NJ','Toledo, OH','Durham, NC','Chula Vista, CA','Fort Wayne, IN',
    'Jersey City, NJ','St. Petersburg, FL','Laredo, TX','Madison, WI','Chandler, AZ',
    'Buffalo, NY','Lubbock, TX','Scottsdale, AZ','Reno, NV','Glendale, AZ','Gilbert, AZ',
    'Winston-Salem, NC','North Las Vegas, NV','Norfolk, VA','Chesapeake, VA','Garland, TX',
    'Irving, TX','Hialeah, FL','Fremont, CA','Boise, ID','Richmond, VA','Baton Rouge, LA',
    'Spokane, WA','Des Moines, IA','Tacoma, WA','San Bernardino, CA','Modesto, CA',
    'Fontana, CA','Santa Clarita, CA','Birmingham, AL','Oxnard, CA','Fayetteville, NC',
    'Rochester, NY','Moreno Valley, CA','Glendale, CA','Huntington Beach, CA','Yonkers, NY',
    'Amarillo, TX','Aurora, IL','Montgomery, AL','Akron, OH','Little Rock, AR','Huntsville, AL',
    'Augusta, GA','Grand Rapids, MI','Overland Park, KS','Tallahassee, FL','Salt Lake City, UT',
    'Worcester, MA','Newport News, VA','Knoxville, TN','Sioux Falls, SD','Providence, RI',
    'Cape Coral, FL','Ontario, CA','Vancouver, WA','Rancho Cucamonga, CA','Peoria, AZ',
    'Springfield, MO','Frisco, TX','Oceanside, CA','Elk Grove, CA','McKinney, TX','Salem, OR',
    'Fort Lauderdale, FL','Corona, CA','Cary, NC','Santa Rosa, CA','Eugene, OR','Jackson, MS',
    'Pembroke Pines, FL','Hayward, CA','Lancaster, CA','Palmdale, CA','Salinas, CA',
    'Springfield, MA','Alexandria, VA','Kansas City, KS','Sunnyvale, CA','Hollywood, FL',
    'Clarksville, TN','Lakewood, CO','Escondido, CA','Torrance, CA','Rockford, IL',
    'Paterson, NJ','Naperville, IL','Savannah, GA','Bridgeport, CT','Mesquite, TX','Killeen, TX',
    'Syracuse, NY','McAllen, TX','Pasadena, TX','Bellevue, WA','Fullerton, CA','Orange, CA',
    'Dayton, OH','Miramar, FL','Thornton, CO','West Valley City, UT','Olathe, KS','Hampton, VA',
    'Warren, MI','Midland, TX','Waco, TX','Charleston, SC','Columbia, SC','Denton, TX',
    'Carrollton, TX','Surprise, AZ','Roseville, CA','Sterling Heights, MI','Murfreesboro, TN',
    'Gainesville, FL','Cedar Rapids, IA','Visalia, CA','Coral Springs, FL','New Haven, CT',
    'Stamford, CT','Thousand Oaks, CA','Concord, CA','Elizabeth, NJ','Lafayette, LA',
    'Kent, WA','Topeka, KS','Simi Valley, CA','Santa Clara, CA','Athens, GA','Hartford, CT',
    'Round Rock, TX','Berkeley, CA','Columbia, MO','Fargo, ND','Ann Arbor, MI','Wilmington, NC',
    // Mid-tier US cities that come up frequently in RSVPs. Free-text is
    // always accepted; this list only makes autocomplete more useful.
    'Davis, CA','Palo Alto, CA','Mountain View, CA','Cupertino, CA','Sunnyvale, CA','Redwood City, CA',
    'San Mateo, CA','Menlo Park, CA','Milpitas, CA','Santa Cruz, CA','Monterey, CA','San Rafael, CA',
    'Emeryville, CA','Alameda, CA','Napa, CA','Santa Barbara, CA','San Luis Obispo, CA','Encinitas, CA',
    'La Jolla, CA','Del Mar, CA','Carlsbad, CA','Manhattan Beach, CA','Culver City, CA','West Hollywood, CA',
    'Boulder, CO','Fort Collins, CO','Golden, CO','Broomfield, CO','Boulder, CO','Steamboat Springs, CO',
    'Asheville, NC','Chapel Hill, NC','Charlottesville, VA','Blacksburg, VA','Reston, VA','Arlington, VA',
    'Missoula, MT','Bozeman, MT','Park City, UT','Bend, OR','Corvallis, OR','Ashland, OR',
    'Bellingham, WA','Olympia, WA','Redmond, WA','Kirkland, WA','Issaquah, WA','Sammamish, WA',
    'Ithaca, NY','Saratoga Springs, NY','Poughkeepsie, NY','Beacon, NY','Kingston, NY','Hudson, NY',
    'Cambridge, MA','Somerville, MA','Newton, MA','Brookline, MA','Northampton, MA','Amherst, MA',
    'Princeton, NJ','Hoboken, NJ','Montclair, NJ','Morristown, NJ',
    'Bethesda, MD','Silver Spring, MD','Rockville, MD','Frederick, MD','Annapolis, MD',
    'Evanston, IL','Oak Park, IL','Naperville, IL','Champaign, IL','Urbana, IL',
    'Ames, IA','Iowa City, IA','Lawrence, KS','Manhattan, KS','Norman, OK','Stillwater, OK',
    'Athens, GA','Savannah, GA','Bend, OR','Portland, ME','Burlington, VT','Providence, RI',
    'Traverse City, MI','East Lansing, MI','State College, PA','Bethlehem, PA','Lancaster, PA'
  ],
  CA: [
    'Toronto, ON','Montreal, QC','Vancouver, BC','Calgary, AB','Edmonton, AB','Ottawa, ON',
    'Winnipeg, MB','Quebec City, QC','Hamilton, ON','Kitchener, ON','London, ON',
    'Victoria, BC','Halifax, NS','Oshawa, ON','Windsor, ON','Saskatoon, SK','Regina, SK',
    'St. John\'s, NL','Kelowna, BC','Barrie, ON','Sherbrooke, QC','Guelph, ON','Kingston, ON',
    'Abbotsford, BC','Trois-Rivières, QC','Saint John, NB','Moncton, NB','Chilliwack, BC',
    'Peterborough, ON','Sudbury, ON','Nanaimo, BC','Fredericton, NB','Charlottetown, PE',
    'Whitehorse, YT','Yellowknife, NT','Red Deer, AB','Lethbridge, AB','Medicine Hat, AB',
    'Kamloops, BC','Prince George, BC','Thunder Bay, ON','Sault Ste. Marie, ON','Cornwall, ON',
    'Belleville, ON','Sarnia, ON','Brantford, ON','Milton, ON','Ajax, ON','Waterloo, ON',
    'Burnaby, BC','Richmond, BC','Surrey, BC','Coquitlam, BC','Delta, BC','Langley, BC',
    'Laval, QC','Longueuil, QC','Gatineau, QC','Lévis, QC','Saguenay, QC','Terrebonne, QC',
    'Repentigny, QC','Saint-Jérôme, QC','Drummondville, QC','Granby, QC','Blainville, QC',
    'Mississauga, ON','Brampton, ON','Markham, ON','Vaughan, ON','Richmond Hill, ON',
    'Oakville, ON','Burlington, ON','Whitby, ON','Cambridge, ON','St. Catharines, ON',
    'Niagara Falls, ON','Newmarket, ON','Chatham, ON','Timmins, ON','Cape Breton, NS'
  ],
  // Fallback: no cities pre-populated for other countries; user free-texts.
};
